module.exports = __webpack_public_path__ + "img/localinfo_nodata.f2e425ec.png";